import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { authApi } from '../services/api';
import '../styles/Login.css';

const Login = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [expiredMessage, setExpiredMessage] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Check if redirected due to expired token (from query param)
    const isExpired = searchParams.get('expired') === 'true';
    if (isExpired) {
      setExpiredMessage('Your session has expired. Please log in again.');
    }
    
    // Check if from PrivateRoute state
    if (location.state?.expired) {
      setExpiredMessage('Your session has expired. Please log in again.');
    }
    
    // Clear any existing tokens on login page load
    const token = localStorage.getItem('token');
    if (token && location.pathname === '/login') {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      console.log('Cleared existing token on login page load');
    }
  }, [location, searchParams]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
    setExpiredMessage(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setExpiredMessage(false);

    try {
      const response = await authApi.login(formData);
      console.log('Login response:', response);
      
      if (response.success) {
        // Store token and user data
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        console.log('Token stored:', response.data.token.substring(0, 50) + '...');
        
        // Set the auth token for future requests
        authApi.setAuthToken(response.data.token);
        
        // Navigate to the original requested page or home
        const from = location.state?.from?.pathname || '/';
        console.log('Navigating to:', from);
        
        // Use window.location for a full page reload to ensure auth context updates
        window.location.href = from;
        
      } else {
        setError(response.message || 'Invalid credentials');
      } 
    } catch (err) {
      console.error('Login error:', err);
      setError(err.message || 'An error occurred during login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>Welcome to Report Generator</h1>
          <p>Sign in to continue</p>
        </div>

        {expiredMessage && (
          <div className="expired-message">
            ⚠️ {expiredMessage}
          </div>
        )}

        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">Username or Email</label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
              disabled={loading}
              placeholder="Enter username or email"
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              required
              placeholder="Enter your password"
              autoComplete="current-password"
              value={formData.password}
              onChange={handleChange}
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            className="login-btn"
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;